import { Image } from '@marriott/mi-ui-library';
import { TabBannerProps } from './Tabs.types';
import { StyledTabBanner } from './Tabs.styles';

export const TabBanner = (props: TabBannerProps) => {
  const { dynamicMedia, theme } = props;

  return (
    <StyledTabBanner $theme={theme}>
      <Image
        renditions={dynamicMedia?.renditions}
        dynamic={dynamicMedia?.dynamic}
        defaultImageURL={dynamicMedia?.assetPath}
        altText={dynamicMedia?.altText}
      />
    </StyledTabBanner>
  );
};
